import { ReportProfileAlertResourceBaseModel } from '../../../profile/report-profile-alert-resource-base-model';
import { SharePointGroupModel } from '../../../microsoft/sharepoint/share-point-group-model';

export class SharePointReportProfileAlertGroupModel extends ReportProfileAlertResourceBaseModel {
  group: SharePointGroupModel;
  allMembers: boolean;
  invalidMemberList: string[];
}
